/* global $ */

class GlassPickerSlider {
  constructor(options = {}) {
    this.config = {
      moduleList: document.querySelectorAll('[data-module="GlassPickerSlider"]'),
      glasspicker: document.querySelector('.js-glass-picker'),
      ...options
    };
  }

  init() {
    const { moduleList, glasspicker } = this.config;

    if (moduleList) {
      moduleList.forEach(module => {
        $(module).slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 2000,
          centerMode: true,
          centerPadding: '10%',
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });

        $('a[data-slide]').click(e => {
          e.preventDefault();
          const slideno = $(this).data('slide');
          $(glasspicker).slick('slickGoTo', slideno - 1);
        });
      });
    }
  }
}

export default GlassPickerSlider;
